const actionPermissions: Record<string, string[]> = {
  view_reports: ["view_dashboard"],
  configure_settings: ["view_roles", "view_permissions"],
  manage_users: ["view_users"],
  view_project_details: ["view_projects"],
  manage_subcontract_works: ["view_subcontract_works"],
  manage_assets: ["view_assets"],
  manage_security_deposits: ["view_security_deposits"],
  manage_EMD: ["view_emds"],
  manage_accounts: ["view_accounts"],
  view_purchase_requests: ["view_purchase_orders"],
  manage_stock: ["view_stocks"],
  log_expenses: ["view_expense_bills"],
  manage_labour: ["view_labours"],
  manage_vehicle: ["view_vehicles"],
  manage_employees: ["view_employees"],
  manage_tools: ["view_tools"],
  approve_travel_allowance: ["view_travel_allowances", "approve_travel_allowances"],
  set_reminders: ["view_reminders"],
  manage_project_documents: ["view_project_documents"],
  track_daily_tasks: ["view_daily_tasks"],
  write_daily_notes: ["view_daily_notes"],
  manage_clients: ["view_clients"],
  manage_sales_customers: ["view_customers"],
  define_services: ["view_services", "view_service_types"],
  manage_suppliers: ["view_suppliers"],
  manage_materials: ["view_materials"],
  manage_bank_accounts: ["view_bank_details"],
  define_work_types: ["view_work_types"],
  define_work_categories: ["view_work_categories"],
  define_project_sections: ["view_sections"],
  define_holidays: ["view_holidays"],
  define_work_locations: ["view_work_locations"],
  define_tax_types: ["view_tax_types"],
  manage_platform: ["manage_platform", "view_platform_analytics"],
  manage_all_companies: ["manage_all_companies"],
  manage_plans: ["manage_plans"],
};

export const canAccessAction = (action: string | undefined, permissions: string[], roles: string[], isPlatformAdmin: boolean = false) => {
  if (!action) {
    return true;
  }

  const superAdminActions = ["manage_platform", "manage_all_companies", "manage_plans"];

  if (isPlatformAdmin) {
    return superAdminActions.includes(action);
  }

  if (roles.includes("Admin")) {
    return !superAdminActions.includes(action);
  }

  const allowedPermissions = actionPermissions[action] || [action];
  return allowedPermissions.some((permission) => permissions.includes(permission));
};

